


<div fxLayout="row">
    <div fxLayout="column" fxFlex="40">
        <mat-toolbar class="m-0 p-4">
            <mat-toolbar-row fxLayout="row" fxLayoutGap="4" fxLayoutAlign="start center">
                <button mat-raised-button  class="save-button" (click)="insertItem('Phase',null,'Nueva etapa')"
                        aria-label="INSERT">
                    <mat-icon>add_box</mat-icon>
                    <span>Etapa</span>
                </button>
                <button mat-raised-button  class="save-button" (click)="insertItem('GeneralTask',activeNode,'Nueva tarea')"
                        aria-label="INSERT" [disabled]="!activeNode || activeNode.type.type !== 'Phase'">
                    <mat-icon>add_box</mat-icon>
                    <span>Tarea</span>
                </button>
                <button mat-raised-button  class="save-button" (click)="moveUp(activeNode)"
                        aria-label="MOVE UP" [disabled]="!activeNode">
                    <mat-icon>arrow_upward</mat-icon>
                </button>
                <button mat-raised-button  class="save-button" (click)="moveDown(activeNode)"
                        aria-label="MOVE DOWN" [disabled]="!activeNode">
                    <mat-icon>arrow_downward</mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>
        <div fxLayout="row" fxFlex="100">
            <div class="fuse-card inner-scroll p-4" fxFlex="100" fusePerfectScrollbar  style="height: 500px;">
                <mat-tree [dataSource]="dataSource" [treeControl]="nestedTreeControl" class="example-tree">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="logNode(node)" [ngClass]="{ 'background-highlight': activeNode === node }">
                        <!--        <li class="mat-tree-node">-->
                        <button mat-icon-button disabled></button>
                        <mat-icon>{{node.type.type === 'Phase' ? 'dashboard' : 'assignment'}}</mat-icon>
                        <button mat-flat-button [style.background]="(activeNode === node) ? '#e6e6e6' : 'inherit'">{{node.name}}</button>
                        <!--        </li>-->
                    </mat-tree-node>

                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
                        <!--        <li>-->
                        <div class="mat-tree-node" (click)="logNode(node)" [ngClass]="{ 'background-highlight': activeNode === node }" >
                            <button mat-icon-button matTreeNodeToggle class="mat-icon-rtl-mirror" >
                                <mat-icon>
                                    {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                            </button>
                            <mat-icon>{{node.type.type === 'Phase' ? 'dashboard' : 'assignment'}}</mat-icon>
                            <button mat-flat-button [style.background]="(activeNode === node) ? '#e6e6e6' : 'inherit'" >{{node.name}}</button>
                        </div>
                        <ul *ngIf="nestedTreeControl.isExpanded(node)">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                        <!--        </li>-->
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
        </div>
    </div>
    <div class="fuse-card" fxFlex="60">
        <entity-info #info></entity-info>
    </div>

</div>